import api from './api';

const settingsService = {
  async getSettings() {
    const response = await api.get('/settings');
    return response.data;
  },
  async updateSettings(data) {
    const response = await api.put('/settings', data);
    return response.data;
  }
};

export default settingsService;